import { HelpIcon, SellerIcon, DownloadAppsIcon, AdIcon, Wishlist, ProfileIcon, OrdersIcon, MyRewardsIcon, ProfileNotificationIcon, PaymentsIcon, VipCrownIcon, ChatIcon, SuperCoinIcon } from 'components/Icons/Icons';
export const VIP_LOCKIN_ID = 'VIP_LOCKIN_ID';
export const DROP_MENU_MAX_WIDTH = 250;
export const ACCOUNT_LINKS = [
    {
        icon: ProfileIcon,
        href: '/account/?rd=0&link=home_account',
        dataAid: 'home_account',
        text: 'My Profile',
        width: 16,
        height: 16
    },
    {
        icon: SuperCoinIcon,
        href: '/supercoin',
        dataAid: 'super_coin',
        text: 'SuperCoin Zone',
        width: 16,
        height: 16
    },
    {
        icon: VipCrownIcon,
        href: '/plus',
        dataAid: 'home_vip',
        text: 'Flipkart Plus Zone',
        width: 16,
        height: 16,
        lockinId: VIP_LOCKIN_ID
    },
    {
        icon: OrdersIcon,
        href: '/account/orders?link=home_orders',
        dataAid: 'home_orders',
        text: 'Orders',
        width: 16,
        height: 12
    },
    {
        icon: Wishlist,
        href: '/wishlist?link=home_wishlist',
        dataAid: 'home_wishlist',
        text: 'Wishlist',
        countType: 'wishlist',
        width: 16,
        height: 14
    },
    {
        icon: ChatIcon,
        href: '/my-chats?link=home_chat',
        dataAid: 'home_chat',
        id: 'MY_CHATS',
        text: 'My Chats',
        width: 16,
        height: 16
    },
    {
        icon: MyRewardsIcon,
        href: '/account/rewards?link=home_rewards',
        text: 'Coupons',
        width: 16,
        height: 16
    },
    {
        icon: PaymentsIcon,
        href: '/the-gift-card-store?link=home_giftcard',
        dataAid: 'home_giftcard',
        text: 'Gift Cards',
        width: 16,
        height: 16
    },
    {
        icon: ProfileNotificationIcon,
        href: '/notifications?otracker=Notifications_view_all',
        dataAid: 'home_notifications_show_all',
        text: 'Notifications',
        countType: 'notification',
        width: 16,
        height: 16
    }
];
export const HELP_LINKS = [
    {
        icon: ProfileNotificationIcon,
        href: '/communication-preferences/push?t=all',
        dataAid: 'communication-preferences',
        id: 'NOTIFICATION_PREFERENCES',
        text: 'Notification Preferences',
        width: 16,
        height: 14
    },
    {
        icon: SellerIcon,
        href: 'https://seller.flipkart.com/?utm_source=flipkart&utm_medium=website&utm_campaign=sellbutton',
        dataAid: 'sell-on-flipkart',
        text: 'Sell on Flipkart',
        openExternal: true,
        width: 16,
        height: 12
    },
    {
        icon: HelpIcon,
        href: '/helpcentre',
        dataAid: '24x7 Customer Care',
        text: '24x7 Customer Care',
        width: 16,
        height: 16
    },
    {
        icon: AdIcon,
        href: 'http://ads.flipkart.com/?otracker=ch_vn_advertise_header',
        dataAid: 'ch_vn_advertise_header',
        openExternal: true,
        text: 'Advertise',
        width: 16,
        height: 14
    },
    {
        icon: DownloadAppsIcon,
        href: '/mobile-apps?otracker=ch_vn_mobile_apps',
        dataAid: 'ch_vn_mobile_apps',
        text: 'Download App',
        width: 16,
        height: 14
    }
];
export const LOGOUT_MENU_LINKS = [
    {
        icon: ProfileIcon,
        href: '/account/?rd=0&link=home_account',
        dataAid: 'home_account',
        text: 'My Profile',
        pageType: 'My_Profile',
        width: 16,
        height: 16
    },
    {
        icon: VipCrownIcon,
        href: '/plus',
        dataAid: 'home_vip',
        text: 'Flipkart Plus Zone',
        width: 16,
        height: 16,
        lockinId: VIP_LOCKIN_ID
    },
    {
        icon: OrdersIcon,
        href: '/account/orders?link=home_orders',
        dataAid: 'home_orders',
        text: 'Orders',
        pageType: 'My_Orders',
        width: 16,
        height: 12
    },
    {
        icon: Wishlist,
        href: '/wishlist?link=home_wishlist',
        dataAid: 'home_wishlist',
        text: 'Wishlist',
        pageType: 'My_Wishlist',
        countType: 'wishlist',
        width: 16,
        height: 14
    },
    {
        icon: MyRewardsIcon,
        href: '/account/rewards?link=home_rewards',
        text: 'Rewards',
        pageType: 'My_Rewards',
        width: 16,
        height: 12
    },
    {
        icon: PaymentsIcon,
        href: '/the-gift-card-store?link=home_giftcard',
        dataAid: 'home_giftcard',
        text: 'Gift Cards',
        width: 16,
        height: 16
    }
];
